<template>
    <div class="title">
        <slot name="index">
            <div class="t1">
                <span class="index">1</span>
                <span class="big-font">梦幻谷</span>--夜游亲子主题公园
            </div>
        </slot>
        <slot name="xc">
            <div class="t2">
                <span class="xc">秋季行程</span>儿童梦工厂、30余项游乐设施、网红超级月亮
            </div>
        </slot>
    </div>

</template>

<script>
    export default {};
</script>

<style lang="stylus" scoped>
    .big-font
        font-size 5.333vw

    .title
        border-radius 2.667vw
        margin 2vw 0
        width 92.8vw
        height 20.133vw
        background-color #B30808
        display flex
        flex-direction column
        align-items center
        justify-content space-evenly
        color #fff

        .t1
            font-size 4.267vw
            font-weight 600
            display flex
            align-items flex-end

            .index
                display flex
                width 6.667vw
                height 6.667vw
                align-items center
                justify-content center
                border-radius 50%
                background-color green
                margin-right 2.667vw

        .t2
            font-size 3.2vw
            width 90%
            text-align center

            .xc
                color #E29E83
                margin-right 2vw
</style>